export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_IS_LOADING = 'GET_IS_LOADING';
export const GET_PAGE_BREADCRUMBS = 'GET_PAGE_BREADCRUMBS';
export const GET_ACTIVE_INVITATIONS = 'GET_ACTIVE_INVITATIONS';
export const GET_USER_LANGUAGE = 'GET_USER_LANGUAGE';
export const GET_OFFER = 'GET_OFFER';
